export const CDN = 'https://d23hwblhugcea5.cloudfront.net';
export const CDN_MARKETPLACE = 'https://d3to9p4w6lww5g.cloudfront.net';
export const S3_BUCKET = 'https://assets2022.s3.amazonaws.com';
export const baseStudio = `${CDN}/studioAssets/`;
export const urlImages = `${baseStudio}gizmoIcons/`;
